import { Div } from "@tblabs/truffle";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { DescriptionPrinter } from "../../Components/Description/Tabs/DescriptionPrinter";
import { AdminMiniButton } from "../../Components/Admin/AdminMiniButton";
import { Page } from "../Product/Page";


export class ArticleViewPage extends Page
{
    constructor(
        private _blog: BlogContentProvider,
        private articleUrl: string)
    {
        super("specTeam.pl - Blog");

        this.PaddingTop(32);

        this.Content(async (body) =>
        {
            await this._blog.Load();

            const article = this._blog.Blog.ArticleByUrl(this.articleUrl);
           
            this.SetTitle(article.Title);

            body.Append(
                this._blog.IsAuthorized && new AdminMiniButton(`blog/${article.Url.value}/edit`, "Edytuj artykuł"),

                new Div("container").Append(
                    new DescriptionPrinter(article.Content),
                )
            );
        });
    }
}
